import React from 'react';
export function Doctors() {
  return <section id="meet-the-doctors" className="py-24 bg-white" data-id="element-33">
      <div className="max-w-7xl mx-auto px-4" data-id="element-34">
        <h2 className="text-3xl font-bold text-[#0F2C59] mb-16 text-center" data-id="element-35">
          MEET YOUR CLINICAL SPECIALISTS
        </h2>

        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-36">
          <div className="flex flex-col md:flex-row gap-8 items-center bg-slate-50 p-8 rounded-[12px]" data-id="element-37">
            <div className="w-48 h-48 rounded-[12px] overflow-hidden flex-shrink-0 shadow-lg" data-id="element-38">
              <img src="https://images.unsplash.com/photo-1559839734-2b71f1536783?auto=format&fit=crop&q=80&w=400" alt="Dr. Simbarashe Parirenyatwa" className="w-full h-full object-cover" data-id="element-39" />
            </div>
            <div data-id="element-40">
              <h3 className="text-2xl font-bold text-[#0F2C59] mb-1" data-id="element-41">
                Dr. Simbarashe Parirenyatwa, DDS
              </h3>
              <p className="text-[#4F709C] font-semibold mb-4" data-id="element-42">
                Lead Clinical Practitioner
              </p>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-43">
                <span className="font-bold" data-id="element-44">Specialty:</span> Advanced Implants
                & Restorative Sedation Care. With over 15 years of experience in
                complex oral rehabilitation.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-center bg-slate-50 p-8 rounded-[12px]" data-id="element-45">
            <div className="w-48 h-48 rounded-[12px] overflow-hidden flex-shrink-0 shadow-lg" data-id="element-46">
              <img src="https://images.unsplash.com/photo-1622253692010-333f2da6031d?auto=format&fit=crop&q=80&w=400" alt="Dr. Simons" className="w-full h-full object-cover" data-id="element-47" />
            </div>
            <div data-id="element-48">
              <h3 className="text-2xl font-bold text-[#0F2C59] mb-1" data-id="element-49">
                Dr. Simons, DDS
              </h3>
              <p className="text-[#4F709C] font-semibold mb-4" data-id="element-50">
                Orthodontic & Cosmetic Specialist
              </p>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-51">
                <span className="font-bold" data-id="element-52">Specialty:</span> Platinum
                Invisalign Provider & Aesthetic Veneers. Focused on creating
                perfectly balanced, natural smiles.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}